const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      content: '+1 (872) 999-8632',
      description: 'Mon-Fri from 9am to 6pm EST',
      color: 'from-violet-500 to-violet-600'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      content: 'support@azzmatrix.com',
      description: 'We\'ll respond within 24 hours',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Office',
      content: '1178 Colfax Ave,',
      description: 'Des Plaines, IL 60016',
      color: 'from-indigo-500 to-indigo-600'
    }
  ];

  const faqs = [
    {
      question: 'What is your response time?',
      answer: 'We typically respond to all inquiries within 24 hours during business days. For urgent IT issues, our Pro plan includes 24/7 support.'
    },
    {
      question: 'Do you offer free consultations?',
      answer: 'Yes, we offer a complimentary 30-minute consultation to assess your IT needs and recommend the best service package for your business.'
    },
    {
      question: 'What is your pricing range?',
      answer: 'Our services range from $100 for basic IT helpdesk support to $750 for comprehensive remote monitoring and management. We offer flexible plans to fit any budget.'
    }
  ];

  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 text-white">
        <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
        <div className="space-y-6">
          {contactMethods.map((method, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br ${method.color} rounded-lg flex-shrink-0`}>
                <i className={`${method.icon} text-white text-xl`}></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-gray-300 mb-1">{method.title}</h4>
                <p className="text-base font-bold mb-1">{method.content}</p>
                <p className="text-sm text-gray-400">{method.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700">
          <h4 className="text-sm font-semibold text-gray-300 mb-4">Follow Us</h4>
          <div className="flex items-center space-x-4">
            <a 
              href="https://linkedin.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-lg hover:bg-violet-500/20 hover:border-violet-400 transition-all cursor-pointer"
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-lg hover:bg-violet-500/20 hover:border-violet-400 transition-all cursor-pointer"
            >
              <i className="ri-twitter-x-fill text-lg"></i>
            </a>
            <a 
              href="https://github.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-lg hover:bg-violet-500/20 hover:border-violet-400 transition-all cursor-pointer"
            >
              <i className="ri-github-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
        <h3 className="text-2xl font-bold text-slate-900 mb-6">Frequently Asked Questions</h3>
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index}>
              <h4 className="text-base font-bold text-slate-900 mb-2">{faq.question}</h4>
              <p className="text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;